import type {
  CreateNewsPostDto,
  NewsListResponse,
  NewsPostDto,
  UpdateNewsPostDto,
} from '@crm/shared'
import { apiClient } from './client'

export async function listNews(
  params: { page?: number; limit?: number } = {},
): Promise<NewsListResponse> {
  const res = await apiClient.get<{ success: true; data: NewsListResponse }>('/news', { params })
  return res.data.data
}

export async function createNewsPost(data: CreateNewsPostDto): Promise<NewsPostDto> {
  const res = await apiClient.post<{ success: true; data: NewsPostDto }>('/news', data)
  return res.data.data
}

export async function updateNewsPost(id: string, data: UpdateNewsPostDto): Promise<NewsPostDto> {
  const res = await apiClient.patch<{ success: true; data: NewsPostDto }>(`/news/${id}`, data)
  return res.data.data
}

export async function deleteNewsPost(id: string): Promise<void> {
  await apiClient.delete(`/news/${id}`)
}
